export default {
  getAll: {
    url: '/api/paymentdetail/getAll',
    method: 'get'
  },
  create: {
    url: '/api/paymentdetail/create',
    method: 'post'
  },
  update: {
    url: '/api/paymentdetail/update',
    method: 'put'
  },
  delete: {
    url: '/api/paymentdetail/delete',
    method: 'delete'
  }
}



// WEBPACK FOOTER //
// ./src/api/paymentdetail.js